import type { SplitWizardStep } from './split-wizard-state';


export type OnboardingSteps = {
    initialStep: SplitWizardStep;
    stepOrder: SplitWizardStep[];
};


const DEFAULT_STEPS: SplitWizardStep[]      = [ 'plan', 'payment' ];
const WITH_COMPANY_STEPS: SplitWizardStep[] = [ 'company', ...DEFAULT_STEPS ];


/** Пришедшему по приглашению нужен шаг компании: при регистрации он её не вводил. */
export const getOnboardingSteps = (companyRequired: boolean): OnboardingSteps => {
    const stepOrder = companyRequired ? WITH_COMPANY_STEPS : DEFAULT_STEPS;

    return { stepOrder, initialStep: stepOrder[0] };
};
